import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: 'Accueil' },
  { href: '/a-propos', label: 'À propos' },
  { href: '/contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-gray-100' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/a3fc7c95-47a5-4f53-b526-26ceb008022d.png"
            alt="WABICH Studio de Design"
            className="h-9 w-auto object-contain"
          />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm tracking-widest uppercase transition-colors duration-200 whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-gray-900'
                  : 'text-gray-500 hover:text-gray-900'
              }`}
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, letterSpacing: '0.1em' }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Mobile hamburger */}
        <button
          aria-label="Menu"
          className="md:hidden flex flex-col justify-center gap-[5px] p-2 cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span
            className={`block w-6 h-px bg-gray-900 transition-all duration-300 origin-center ${
              menuOpen ? 'rotate-45 translate-y-[6px]' : ''
            }`}
          />
          <span
            className={`block w-6 h-px bg-gray-900 transition-all duration-300 ${
              menuOpen ? 'opacity-0 scale-x-0' : ''
            }`}
          />
          <span
            className={`block w-6 h-px bg-gray-900 transition-all duration-300 origin-center ${
              menuOpen ? '-rotate-45 -translate-y-[6px]' : ''
            }`}
          />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden bg-white border-t border-gray-100 transition-all duration-300 overflow-hidden ${
          menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`py-3 text-sm tracking-widest uppercase border-b border-gray-50 transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === link.href ? 'text-gray-900' : 'text-gray-500'
              }`}
              style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400 }}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}
